import api from "APP_ROOT/api";
import { createPaginatedList } from "MODULES/shared/pagination";
import createStore from "APP_ROOT/createStore";
import { ID } from "APP_ROOT/constants";
import { CONSIGNMENT } from "MODULES/Receiving/constants";
import { combineReducers } from "redux";

export const consignmentInventoriesPagination = createPaginatedList({
  listId: "consignments/inventories",
  stateLocator: state => state.consignments.inventories,
  initialSettings: {
    pageSize: 15
  },
  fetch: search => {
    const id = createStore()
      .getState()
      .consignmentDetail.getIn([CONSIGNMENT, ID]);
    return api.consignments.inventories.search(id, search);
  }
});

export const consignmentLineItemsPagination = createPaginatedList({
  listId: "consignments/lineItems",
  stateLocator: state => state.consignments.lineItems,
  initialSettings: {
    pageSize: 15
  },
  fetch: search => {
    const id = createStore()
      .getState()
      .consignmentDetail.getIn([CONSIGNMENT, ID]);
    return api.consignments.lineItems.search(id, search);
  }
});

export const consignmentsPagination = createPaginatedList({
  listId: "consignments",
  stateLocator: state => state.consignments.main,
  fetch: api.consignments.search
});

export default combineReducers({
  main: consignmentsPagination.paginator,
  inventories: consignmentInventoriesPagination.paginator,
  lineItems: consignmentLineItemsPagination.paginator
});



// WEBPACK FOOTER //
// ./app/modules/Consignments/pagination.js